import styled from "@emotion/styled";
import {Tooltip} from "@blueprintjs/core";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import VehicleIconResolver from "../../vehicles/VehicleIconResolver";

export type DriverPinProps = {
  lat: number;
  lng: number;
  driverCode: string;
  vehicleIcon: ReturnType<typeof VehicleIconResolver>;
  color: string;
  newWindow?: Window;
  usePortal?: boolean;
};

export const DriverPin = ({driverCode, vehicleIcon, color, newWindow, usePortal}: DriverPinProps) => (
  <Tooltip
    content={driverCode}
    placement="top"
    popoverClassName="marker-popover"
    usePortal={usePortal}
    portalContainer={newWindow?.document.body}
  >
    <DriverPinWrapper data-testid="driver-pin-wrapper" data-color={color}>
      <FontAwesomeIcon icon={vehicleIcon} color={color} size="lg" />
    </DriverPinWrapper>
  </Tooltip>
);

const DriverPinWrapper = styled.div`
  cursor: pointer;
  background-color: white;
  border-radius: 50%;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
`;
